import { createElement, type ReactNode } from 'react';

/**
 * Подсветка вхождений запроса в тексте (`<mark>` с классом `className`): без регулярных выражений (спецсимволы
 * запроса безопасны), без учёта регистра, все вхождения.
 */
export function highlightMatches(text: string, query?: string, className = 'rf-hl'): ReactNode {
    const q = query?.trim();
    if (!q) return text;
    const lower = text.toLowerCase();
    const lq = q.toLowerCase();
    if (!lower.includes(lq)) return text;

    const parts: ReactNode[] = [];
    let i = 0;
    for (let j = lower.indexOf(lq, i); j !== -1; j = lower.indexOf(lq, i)) {
        if (j > i) parts.push(text.slice(i, j));
        parts.push(createElement('mark', { key: j, className }, text.slice(j, j + q.length)));
        i = j + q.length;
    }
    if (i < text.length) parts.push(text.slice(i));
    return parts;
}
